<template>
  <div class="module-lesson-quiz-list">
    <carousel
      :per-page-custom="[
        [200, 1.2],
        [400, 2.2],
        [768, 3.5],
        [992, 4.5],
        [1500, 4.8]
      ]"
      :pagination-enabled="false"
      navigation-enabled
      navigation-next-label="<i class='icon-chevron-right'></i>"
      navigation-prev-label="<i class='icon-chevron-left'></i>"
      :mouse-drag="false"
    >
      <slide v-for="(item, i) in items" :key="i" class="pr-4">
        <lesson-quiz-item :item="item" />
      </slide>
    </carousel>
  </div>
</template>

<script>
import LessonQuizItem from "@/components/lesson/LessonQuizItem";
import { Carousel, Slide } from "vue-carousel";

export default {
  components: { LessonQuizItem, Carousel, Slide },
  props: {
    items: {
      type: Array,
      required: true
    }
  }
};
</script>
